<template>
  <div style="height: 100%; overflow: hidden">
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Phản hồi" :link="[{ text: 'Phản hồi', href: '../feedback' }]" />
      </div>
    </div>

    <div class="mb-8">
      <v-card class="mx-4 pa-4" elevation="0" outlined>
        <FeedbackFilter @onFilterChanged="onFilterChanged" />
      </v-card>
    </div>

    <div v-if="hasData">
      <v-row class="pb-4">
        <!-- message group -->
        <FeedbackGroupSelector
          :busy="busy"
          :windowHeight="windowHeight"
          @on-scroll="loadMore"
          @on-group-click="groupClicked"
        />

        <!-- chat -->
        <v-col cols="12" md="8" v-if="$_get(messageGroup, 'id')" class="div-border mt-3">
          <div id="chat" v-if="!messageLoading">
            <FeedbackChatboxHeader />

            <div
              v-chat-scroll="{ always: false, scrollonremoved: true }"
              id="messages-window"
              :style="{ height: windowHeight - 500 + 'px !important' }"
            >
              <div v-for="message in messages" :key="message.id" id="message-container">
                <FeedbackChatboxMessage :message="message" />
              </div>
            </div>

            <!-- input chat -->
            <v-row>
              <v-col class="pt-4 pl-8" cols="1">
                <v-file-input
                  dense
                  accept="image/png, image/jpeg, image/bmp"
                  prepend-icon="mdi-camera"
                  hide-input
                  @change="onChange"
                />
              </v-col>
              <v-col cols="11">
                <v-text-field
                  placeholder="Nhập phản hồi..."
                  v-model="content"
                  :disabled="sending"
                  :loading="sending"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-send"
                  type="text"
                  class="input"
                  @click:append="send()"
                  @keyup.enter="send()"
                />
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <v-skeleton-loader type="article, article, article" />
          </div>
        </v-col>
        <v-col v-else class="d-flex justify-center align-center mr-4 mt-3 div-border">
          <div>Vui lòng chọn cuộc hội thoại</div>
        </v-col>
      </v-row>
    </div>
    <div class="text-h5 d-flex text-center justify-center align-center" style="height: 100%; overflow: hidden" v-else>
      Chưa có phản hồi từ phụ huynh
    </div>
  </div>
</template>
<script>
import FeedbackGroupSelector from './modules/FeedbackGroupSelector.vue'
import FeedbackChatboxHeader from './modules/chatbox/FeedbackChatboxHeader.vue'
import FeedbackChatboxMessage from './modules/chatbox/FeedbackChatboxMessage.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import FeedbackFilter from './modules/FeedbackFilter.vue'
import { textHelpers } from '@/helpers/TextHelper.js'
import Vue from 'vue'
import VueChatScroll from 'vue-chat-scroll'
import moment from 'moment'
import VueImg from 'v-img'
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
Vue.use(VueImg)
Vue.use(VueChatScroll)

export default {
  components: {
    Breadcrumbs,
    FeedbackFilter,
    FeedbackGroupSelector,
    FeedbackChatboxHeader,
    FeedbackChatboxMessage,
  },
  data() {
    return {
      windowHeight: window.innerHeight,
      content: '',
      interval: null,
      sending: false,
      busy: false,
      messageGroupParams: {},
      firstLoadData: false,
    }
  },

  async created() {
    this.firstLoadData = true
    if (this.role.type === 'teacher') {
      this.messageGroupParams = { type: 'teacher' }
      // chi lay nhom chat lop dang chu nhiem
      if (this.profile.ownClasses && this.profile.ownClasses.length) {
        const ownClassIds = this.profile.ownClasses.map(c => c.id)
        this.messageGroupParams['class_in'] = ownClassIds
      } else {
        this.messageGroupParams = null
      }
    } else {
      this.messageGroupParams = { type: 'manager' }
    }
    if (this.messageGroupParams) await this.fetchMessageGroups({ ...this.messageGroupParams, _limit: 15 })

    if (this.$route.params.id) {
      const group = this.messageGroups.find(g => g.id === this.$route.params.id)
      if (group && group.id) await this.groupClicked(group)
      else this.$router.push(`/feedback`)
    }
    this.firstLoadData = false

    // interval fetch messages
    this.setIntervalMessageFetching()
  },

  computed: {
    ...mapState('Feedback', ['messages', 'messageGroup', 'groupNo', 'loading', 'messageLoading']),
    ...mapGetters('Feedback', ['messageGroups']),
    ...mapGetters('auth', ['profile', 'role']),
    hasData() {
      return this.firstLoadData || (Array.isArray(this.messageGroups) && this.messageGroups.length > 0)
    },
  },
  methods: {
    ...mapActions('Feedback', [
      'fetchMessageGroups',
      'fetchMessages',
      'createMessage',
      'uploadImage',
      'searchMessageGroups',
    ]),

    setIntervalMessageFetching() {
      this.interval = setInterval(async () => {
        if (this.messageGroupParams) {
          await this.fetchMessageGroups({ ...this.messageGroupParams, _limit: this.messageGroups.length })
        }
        if (this.messageGroup.id) {
          const isSameId = this.$route.params.id === this.messageGroup.id
          await this.fetchMessages({ ...this.messageGroup, isSameId })
        }
      }, 60000)
    },

    async onFilterChanged(params) {
      if (this.role.type === 'teacher') params.type = 'teacher'
      else params.type = 'manager'
      this.messageGroupParams = { ...this.messageGroupParams, ...params }
      await this.searchMessageGroups({ ...params, _sort: 'lastMessageTime:desc', _limit: 15 })
    },
    onChange(file) {
      if (file) {
        if (typeof this.$rules.imageChat(file) === 'string') return this.$alert.error(this.$rules.imageChat(file))
        this.send(file)
      }
    },
    async send(image) {
      if (this.sending || (!image && (!this.content || !textHelpers.removeSpaces(this.content)))) return

      const data = {
        time: moment().toISOString(),
        sender: this.profile.user,
        messageGroup: this.messageGroup.id,
      }

      if (!image) data.content = this.content

      try {
        this.sending = true
        const createdMessage = await this.createMessage(data)

        if (image) {
          // image
          let formData = new FormData()
          formData.append('files', image)
          formData.append('refId', createdMessage.id)
          formData.append('ref', 'message')
          formData.append('field', 'image')

          this.uploadImage(formData)
        }

        if (!image) this.content = ''
        await this.fetchMessageGroups(this.messageGroupParams)
      } catch (error) {
        this.$alert.error('Gửi thất bại, vui lòng thử lại')
      } finally {
        this.sending = false
      }
    },
    loadMore() {
      if (this.messageGroups.length < this.groupNo && !this.busy) {
        this.busy = true

        setTimeout(async () => {
          await this.fetchMessageGroups({ ...this.messageGroupParams, _limit: this.messageGroups.length + 10 })
          this.busy = false
        }, 1500)
      }
    },

    onResize() {
      this.windowHeight = window.innerHeight
    },
    async groupClicked(group) {
      const isSameId = this.$route.params.id === group.id
      const messageGroup = { ...group, isUpdateLastSeen: true, isSameId }
      await this.fetchMessages(messageGroup)
      // if (!isSameId) this.$router.push(`/feedback/${group.id}`)
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  },
}
</script>

<style scoped>
#chat {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;
}

#messages-window {
  background: #eee;
  overflow: scroll;
  padding: 20px;
}

.div-border {
  outline: 1px solid #d3d3d3;
}
</style>
